export default class Header{
    
    constructor() {
        this._header = document.querySelector('.header');
        this._burger = this._header.querySelector('.js-header-burger');
        this._overlay = document.querySelector('.js-header-overlay');
        this._searchPopin = document.querySelector('.js-header-search');
        this._searchPopinOverlay = document.querySelector('.js-header-search-overlay');
        this._searchPopinInput = document.querySelector('.js-header-search-input');
        this._searchPopinOpen = document.querySelectorAll('.js-search-open');
        
        this.bindEvents();
    }
    
    bindEvents(){
        this._burger.addEventListener('click', () => {
           this._header.classList.toggle('is-open'); 
           this._overlay.classList.toggle('is-open');
        });   
        
        this._overlay.addEventListener('click', () => {
           this._header.classList.remove('is-open');
           this._overlay.classList.remove('is-open');
        });
        app.nodesEventListener('click', this._searchPopinOpen, this.openSearchPopin.bind(this));
        this._searchPopinOverlay.addEventListener('click', this.closeSearchPopin.bind(this));
    }
    
    openSearchPopin(){
        this._searchPopin.classList.add('is-open');
        setTimeout(() => {
            this._searchPopinInput.focus();
        }, 250);
    }
    
    closeSearchPopin(){
        this._searchPopin.classList.remove('is-open');
    }
}